import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { IManufacturer } from 'parts/types';

export const getMany = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IManufacturer>> => {
  const { data } = await partfinitiClient.get(
    `/manufacturers/index/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IManufacturer>(data.manufacturers, data.total_count);
};
